import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { ListMagnifyingGlass } from "@phosphor-icons/react";

export default function AuditLog() {
  const { data, loading, error } = useFetch("/audit");
  if (loading) return <Loading />;
  if (error) return <PageHeader icon={ListMagnifyingGlass} title="Audit Log" subtitle="Owner/Admin access required." />;

  return (
    <div>
      <PageHeader icon={ListMagnifyingGlass} title="Audit Log"
        subtitle="Important actions across the platform. Passwords and full API keys are never logged." />
      {(!data || data.length === 0) ? <p className="text-sm text-zinc-500">No activity recorded yet.</p> : (
        <Panel className="p-0 overflow-hidden">
          {data.map((a, i) => (
            <div key={a.id} data-testid={`audit-${i}`} className={`flex items-center gap-4 p-3.5 ${i !== data.length - 1 ? "border-b border-white/5" : ""}`}>
              <Tag className="text-[10px] font-mono">{a.action}</Tag>
              <div className="flex-1 min-w-0"><span className="text-sm text-white">{a.who}</span> <span className="text-sm text-zinc-500">{a.detail}</span></div>
              <span className="text-xs text-zinc-600 shrink-0">{a.at ? new Date(a.at).toLocaleString() : ""}</span>
            </div>
          ))}
        </Panel>
      )}
    </div>
  );
}
